import { useEffect, useRef, useState } from "react"
import { ISearchBox } from "@fluentui/react";
import { IRequestModeloEquipoAuxiliar, ITableModeloEquipo } from "../../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import EquipoModeloService from "../../../../services/ListaVerificacion/EquipoModeloService";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";

export const UseEquipoModeloTable = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const onChangeSearch = useRef<ISearchBox>(null);
  const [items, setItems] = useState<ITableModeloEquipo[]>([]);
  const InitialFilter: IRequestModeloEquipoAuxiliar = {
    skip: 0,
    take: 50,
    search: "",
    equipoAuxiliar: true
  };

  const [filterTable, setFilterTable] = useState<IRequestModeloEquipoAuxiliar>(InitialFilter);

  useEffect(() => {
    if (filterTable) {
      getEquipoModelos()
    }
  }, [filterTable])
  
  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilterTable({ ...filterTable, search: value });
  };

  const onChangeTake = (value: number) => {
    setFilterTable({ ...filterTable, take: value })
  };
  const onSkip = (value: number) => {
    const realSkip = (value * filterTable.take) - filterTable.take
    setFilterTable({ ...filterTable, skip: realSkip })
  };


  const [pagination, setPagination] = useState<IPaginationV2>({
    currentPage: 0,
    total: 0,
    pageSize: 0,
    skip: 0,
    take: 50,
    onPageChange: function (value: number): void {
    },
    onSizeChange: function (value: number): void {
    }
  })

  const handleResetUpdate = () => {
    setFilterTable(InitialFilter);
  };

  const getEquipoModelos = () => {
    setLoading(true)
    EquipoModeloService.PostTableEquipoModelo(filterTable).then((res) => {
      const pag: IPaginationV2 = {
        currentPage: res.data.page,
        total: res.data.total,
        pageSize: res.data.pages,
        onPageChange: onSkip,
        skip: filterTable.skip,
        take: filterTable.take,
        onSizeChange: onChangeTake
      };
      setPagination(pag)
      setLoading(false)
      setItems(res.data.items)
    }).catch((e: any) => {
      setLoading(false)
    })
  }
  return {
    items,
    filterTable,
    setFilterTable,
    loading, 
    pagination,
    getEquipoModelos,
    handleResetUpdate,
    onChangeSearch,
    onChangeTake,
    _onkeyUpSearchTable
  }
}